import type { AppLanguage } from '@/shared/i18n/types';

import enFile from './en.json';
import jaFile from './ja.json';

const ja = (jaFile as { common: any }).common;
const en = (enFile as { common: any }).common;

export const commonNamespaceResources: Record<AppLanguage, any> = {
  ja,
  en,
};
